<template>
    <div>
        <v-tooltip v-if="blockNotificaciones" bottom>
            <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-bell-cancel</v-icon>
            </template>
            <span>Notificaciones desactivadas</span>
        </v-tooltip>
        <v-menu v-else v-model="menu" :close-on-content-click="false" bottom left>
            <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                    <v-badge overlap color="red" :value="noLeidas">
                        <template v-if="noLeidas > 0" v-slot:badge>{{ noLeidas }}</template>
                        <v-icon>mdi-bell</v-icon>
                    </v-badge>
                </v-btn>
            </template>

            <v-card width="500px" style="max-height: 600px;" flat>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12 sm12 md12>
                            <v-list dense subheader>
                                <!-- Agregar botón para eliminar notificaciones -->
                                <v-card-actions>
                                    <v-subheader>NOTIFICACIONES</v-subheader>
                                    <v-spacer></v-spacer>
                                    <v-tooltip left v-if="notificaciones.length != 0">
                                        <template v-slot:activator="{ on: tooltip }">
                                            <v-btn icon small fab color="red" v-on="{ ...tooltip }"
                                                @click="limpiarNotificaciones()">
                                                <v-icon>mdi-playlist-remove</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Eliminar notificaciones</span>
                                    </v-tooltip>
                                </v-card-actions>

                                <!-- Botón para eliminar notificaciones -->
                                <v-divider></v-divider>
                                <v-list-item v-if="notificaciones.length == 0"><i>No hay notificaciones para
                                        mostrar.</i></v-list-item>
                                <div v-for="(item, index) in notificaciones" :key="index">
                                    <!-- SI NO ES DE OFICIO -->
                                    <v-list-item v-if="!item.solicitud" three-line link>
                                        <v-list-item-avatar @click="verNotificacion(item, index)">
                                            <v-icon :color="item.leido ? 'grey' : 'orange'">mdi-bell</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content @click="verNotificacion(item, index)">
                                            <v-list-item-title
                                                v-if="item.oficio.entrante">{{ item.oficio.entrante.numero }}</v-list-item-title>
                                            <v-list-item-title
                                                v-if="item.oficio.generado">{{ numeroGenerado(item.oficio.generado.numero) }}</v-list-item-title>
                                            <v-list-item-title v-text="item.titulo"></v-list-item-title>
                                            <v-list-item-subtitle>{{ formatoFecha(item.fecha) }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-btn fab icon x-small color="red"
                                                @click="eliminarNotificacion(item, index)">
                                                <v-icon size="13">fa-times</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <!-- SI ES DE SOLICITUD -->
                                    <v-list-item v-else three-line link>
                                        <v-list-item-avatar @click="verNotificacion(item, index)">
                                            <v-icon :color="item.leido ? 'grey' : 'orange'">mdi-bell</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content @click="verNotificacion(item, index)">
                                            <v-list-item-title>Solicitud de Centro Universitario</v-list-item-title>
                                            <v-list-item-title v-text="item.titulo"></v-list-item-title>
                                            <v-list-item-subtitle>{{ item.fecha && formatoFecha(item.fecha) }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-btn fab icon x-small color="red"
                                                @click="eliminarNotificacion(item, index)">
                                                <v-icon size="13">fa-times</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <v-divider></v-divider>
                                </div>
                            </v-list>
                        </v-flex>
                    </v-layout>
                </v-container>

            </v-card>
        </v-menu>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import { DateTime,Settings } from 'luxon';

import { cargarNotificacionesService, limpiarNotificacionesService } from "./notificaciones.service";
Settings.defaultLocale = 'es';
export default {
    name: 'notificacionesBtn',
    props: ['apps'],
    computed: {
        ...mapGetters([
            "httpURL",
            "sessionToken",
            "userId",
            "blockNotificaciones"
        ]),
        noLeidas() {
            return this.notificaciones.filter(x => x.leido == false).length;
        }
    },
    sockets: {
        conectado() {
            console.log('conectado');
        },
        nuevaNotificacion(data) {
            //   console.log(data);
            this.cargaNotificaciones();
        }
    },
    data: () => ({
        menu: false,
        notificaciones: [],
        loading: false,
    }),
    created() {
        this.cargaNotificaciones();
    },
    methods: {
        numeroGenerado(numeroOficio) {
            let numero = `${numeroOficio.secretaria}/${numeroOficio.dependencia}/${numeroOficio.mes}/${numeroOficio.numero}/${numeroOficio.anio}`;
            if (numeroOficio.secretaria == 'CGU')
                numero += '/' + numeroOficio.comision;
            return numero;
        },
        formatoFecha(fecha) {
            return DateTime.fromJSDate(new Date(fecha)).toFormat("dd 'de' LLLL 'de' yyyy HH:mm 'hrs.'")
        },
        verNotificacion(notificacion, index) {
            if (notificacion.oficio.entrante) {
                if (notificacion.oficio.entrante.relacionado.id)
                    this.$router.push('/oficios/' + notificacion.oficio.entrante.relacionado.tipo + '/' + notificacion.oficio.entrante.relacionado.id);
                else
                    this.$router.push('/oficios/entrante/' + notificacion.oficio.entrante._id);
            }
            if (notificacion.oficio.generado)
                if (notificacion.oficio.generado.relacionado.id)
                    this.$router.push('/oficios/' + notificacion.oficio.generado.relacionado.tipo + '/' + notificacion.oficio.generado.relacionado.id);
                else
                    this.$router.push('/oficios/generado/' + notificacion.oficio.generado._id);
            if (notificacion.solicitud)
                this.$router.push('/centros/solicitud/' + notificacion.solicitud);
            this.menu = false;
            //Se manda la notificación vista
            axios.put(this.httpURL + '/notificaciones/leido/' + notificacion._id, {},
                { headers: { token: this.sessionToken } })
                .then(res => {
                    // console.log(res.data);
                    if (res.data.ok) {
                        this.notificaciones[index].leido = true;
                    } else {
                        // this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                    }
                    this.loading = false;
                })
                .catch(error => {
                    // console.log('Error: '+error);
                    this.loading = false;
                    this.$notify({ group: 'gral_notif', type: "error", duration: 1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                });
            // console.log('Se redirecciona a la notificación');
        },
        eliminarNotificacion(notificacion, index) {
            axios.delete(this.httpURL + '/notificaciones/' + notificacion._id,
                { headers: { token: this.sessionToken } })
                .then(res => {
                    // console.log(res.data);
                    if (res.data.ok) {
                        this.notificaciones.splice(index, 1);
                    } else {
                        this.$notify({ group: 'gral_notif', type: "error", duration: 1500, speed: 500, text: res.data.mensaje });
                    }
                    this.loading = false;
                })
                .catch(error => {
                    // console.log('Error: '+error);
                    this.loading = false;
                    this.$notify({ group: 'gral_notif', type: "error", duration: 1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                });
        },
        // Funciones actualizadas
        async cargaNotificaciones() {
            try {
                this.loading = true;
                const serverResponse = await cargarNotificacionesService();
                this.loading = false;
                if (!serverResponse.ok) throw Error(serverResponse.mensaje);
                else {
                    this.notificaciones = serverResponse.notificaciones;
                }
            } catch (error) {
                this.loading = false;
                this.$notificarError(error.message);
            }
        },
        async limpiarNotificaciones() {
            try {
                this.loading = true;
                const serverResponse = await limpiarNotificacionesService(this.userId);
                this.loading = false;
                if (!serverResponse.ok) throw new Error(serverResponse.mensaje);
                else {
                    this.$notify({
                        group: "gral_notif",
                        type: "success",
                        duration: 1500,
                        speed: 500,
                        text: serverResponse.mensaje,
                    });
                    this.notificaciones = serverResponse.notificaciones;
                }
            } catch (error) {
                this.loading = false;
                this.$notificarError(error.message);
            }


        }
    }
}
</script>